import { BreakpointsContextType } from '@cvent/carina/components/Breakpoints';

type CustomBreakpoints = {
  isMobile: boolean;
  isDesktop: boolean;
  isMobileOrTablet: boolean;
};

export const useCustomBreakpoints = (breakpoints: BreakpointsContextType): CustomBreakpoints => {
  return {
    isMobile: breakpoints.isDefaultSize || breakpoints.isS,
    isDesktop: breakpoints.isM || breakpoints.isL || breakpoints.isXL,
    isMobileOrTablet: breakpoints.isDefaultSize || breakpoints.isS || breakpoints.isM
  };
};
